"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFPSMeterAction = void 0;
var tslib_1 = require("tslib");
require("fpsmeter");
var inversify_1 = require("inversify");
var utils_1 = require("@dp-instant/utils");
var core_1 = require("@dp-instant/core");
var settings_1 = require("../settings");
var CreateFPSMeterAction = (function (_super) {
    tslib_1.__extends(CreateFPSMeterAction, _super);
    function CreateFPSMeterAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreateFPSMeterAction.prototype.execute = function (options) {
        if (options === void 0) { options = settings_1.Settings.debug.fpsMeter; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rootElement, el, fpsmeter_1, tick_1;
            return tslib_1.__generator(this, function (_a) {
                utils_1.log.debug("createFPSMeter");
                if (typeof FPSMeter !== "undefined") {
                    rootElement = document.getElementById(core_1.CANVAS_ID);
                    el = document.createElement("div");
                    document.body.insertBefore(el, rootElement.parentElement);
                    fpsmeter_1 = new FPSMeter(el, options);
                    fpsmeter_1.show();
                    tick_1 = function () {
                        fpsmeter_1.tick();
                        requestAnimationFrame(tick_1);
                    };
                    tick_1();
                }
                return [2];
            });
        });
    };
    CreateFPSMeterAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], CreateFPSMeterAction);
    return CreateFPSMeterAction;
}(core_1.Action));
exports.CreateFPSMeterAction = CreateFPSMeterAction;
//# sourceMappingURL=CreateFPSMeterAction.js.map